import React from "react";
import { LuiFormikForm, LuiFormSubmitButton } from "@linzjs/lui";
import { withRouter } from "react-router";
import { TextInput } from "./Forms";
import { Auth } from "aws-amplify";

class Login extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      username: "",
      password: "",
      loading: false
    };

    this.handleInputChange = this.handleInputChange.bind(this);
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.value;
    const name = target.name;

    this.setState({
      [name]: value
    });
  }
  
  handleSubmit() {
    this.setState({ loading: true });

    Auth.signIn(this.state.username, this.state.password)
    .then(user => {
      this.props.handleSignIn();
    })
    .catch(error => {
      console.log(error);
      this.setState({ loading: false });
    });
  }

  render() {
    const { loading } = this.state;
    return (
      <>
        <div className="g-flex-row">
          <div className="lui-text-content-area">
            <p>LINZ holds historic Crown property paper files from its predecessor organisations,
              such as the Department of Survey & Land Information (DoSLI), Department of Lands
              and Survey and Ministry of Works. Crown property accredited suppliers use these
              files to undertake the acquisition or disposal of land for Crown agencies.
              LINZ makes information on the files created prior to 2005 available through the
              ELFI database for this purpose.</p>
            <p>The LINZ ELFI database is available to:</p>
            <ul>
              <li>Crown property accredited suppliers and their staff</li>
              <li>researchers approved by LINZ</li>
            </ul>
            <LuiFormikForm
              initialValues={{partial: "on"}}
              onSubmit={this.handleSubmit.bind(this)}>
              <fieldset>
                <div className="lui-text-content-area">
                  <TextInput name="username" label="User" value={this.state.username} onChange={this.handleInputChange} />
                  <TextInput type="password" name="password" label="Password" value={this.state.password} onChange={this.handleInputChange} />
                  <div className="lui-text-content-area">
                    <p>
                      <LuiFormSubmitButton disabled={loading}>LINZ Login</LuiFormSubmitButton>
                    </p>
                  </div>
                </div>
              </fieldset>
            </LuiFormikForm>
          </div>
        </div>
      </>
    );
  }
}

export default withRouter(Login);
